<template>
  <BaseModal
    :heading="t('treatwell.kyc_ultimatum.header')"
    useForm
    testId="treatwell-kyc-ultimatum"
    small
    grey
    @close="close"
    @submit="submit"
  >
    <BaseCard noPadding>
      <div :class="$style.content">
        <img
          src="/img/treatwell/verification-process.svg"
          :class="$style.visual"
        >
        <BaseHeading>
          {{ t('treatwell.kyc_ultimatum.disclaimer.header') }}
        </BaseHeading>
        <BaseText>{{ t('treatwell.kyc_ultimatum.disclaimer.text') }}</BaseText>
      </div>
    </BaseCard>
    <template #footerSub>
      <BaseText :href="helpCenterArticleUrl(9863280)">
        {{ t('global.learn_more') }}
      </BaseText>
    </template>
    <template #footer>
      <BaseButton
        color="inverted"
        @click="showCancelModal"
        v-test="'kyc-ultimatum-churn'"
      >
        {{ t('treatwell.churn') }}
      </BaseButton>
      <BaseButton
        submitForm
        v-test="'kyc-ultimatum-start'"
      >
        {{ t('banner.kyc_button') }}
      </BaseButton>
    </template>
  </BaseModal>
</template>

<script
  setup
  lang="ts"
>
import { useMutation } from '@vue/apollo-composable';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import { helpCenterArticleUrl } from '@/helpers/help-center';
import { modal } from '@/helpers/ui';
import { useTreatwellStore } from '@/stores/treatwell';
import { TREATWELL_INTEGRATION_REQUEST_REJECT } from '../graphql';

const { dismissKYCModal } = useTreatwellStore();
const { t } = useI18n();
const router = useRouter();
const emit = defineEmits(['close', 'submit']);

const { getTreatwellStatus } = useTreatwellStore();

const close = () => {
  emit('close');
  dismissKYCModal();
};

const submit = () => {
  close();
  router.push({
    name: 'treatwell-kyc-start',
  });
};

const { mutate: treatwellIntegrationRequestReject } = useMutation(
  TREATWELL_INTEGRATION_REQUEST_REJECT,
  () => ({
    variables: {
      input: {
        rejectionReason: 'churned from dashboard',
      },
    },
  }),
);
const showCancelModal = () => {
  close();
  modal('confirmation', {
    message: t('treatwell.churn_modal.message'),
    type: 'disable',
    warning: t('treatwell.churn_modal.sub_message'),
  }).then(() => {
    treatwellIntegrationRequestReject().then(() => {
      getTreatwellStatus();
    });
  });
};
</script>

<style
  lang="scss"
  module
>
.content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 0.5 * $spacing;
  padding: 1.5 * $spacing;
}

.visual {
  width: 176px;
  max-width: 50%;
  max-height: 150px;
  padding-bottom: $spacing;
}
</style>
